<template>
    <div class="white-box white-box-no-tab">
        <TermsFrame
            title="保險單借款"
            needLayer
            needGuideArrow
            :isLoading="isLoading"
            :needBtn="isScrollToBottom"
            :content="content"
            @isScrollToBottom="v => isScrollToBottom = v"
        >
            <template #subtitle>
                <p class="text-error mb-4">
                    『經濟弱勢保戶保單借款優惠利率』方案申請說明
                </p>
            </template>
            <template #action>
                <div
                    v-if="isScrollToBottom && content"
                    class="text-center mb-5"
                >
                    <button
                        class="btn bg-white hover:bg-accent  hover:border-gray-50 text-gray-800 rounded-full mx-2 mb-1"
                        @click="postApply(false)"
                    >
                        不申請
                    </button>
                    <button
                        class="btn bg-white hover:bg-accent  hover:border-gray-50 text-gray-800 rounded-full mx-2 mb-1"
                        @click="postApply(true)"
                    >
                        申請
                    </button>
                </div>
            </template>
        </TermsFrame>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, inject } from 'vue';
import { useRouter } from 'vue-router';
import TermsFrame from '@/components/template/TermsFrame.vue';
import routeName from '@/router/constant';
import { getAgreeTermsBailout, postAgreeBailout } from '@/apis/Pon4300Bailout.js';
import Loading from '@/components/Loading.vue';

export default {
    name: 'LoanApply',
    components: {
        TermsFrame,
        Loading
    },
    setup() {
        const $vfm = inject('$vfm');
        const router = useRouter();
        const content = ref('');
        const isLoading = ref(false);
        const isScrollToBottom = ref(false);
        const openModal = (params, on) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on,
            });
        };
        const getTerms = () => {
            getAgreeTermsBailout().then(res => {
                if (res.data.agreeTerms) content.value = res.data.agreeTerms.content;
            });
        };
        getTerms();

        const postApply = (isApply) => {
            isLoading.value = true;
            postAgreeBailout().then(res => {
                if (!isApply) {
                    goOTP();
                } else if (res.data.payoff) {
                    router.push({ name: routeName.LOAN_PROGRAM_DOCUMENTS });
                } else {
                    isLoading.value = false;
                    openModal({
                        title: '請確認',
                        content: '要保人曾辦理借款紓困專案但尚未全部清償，無法再次申辦，將改採一般借款方案辦理',
                        confirmButton: '確認',
                    }, {
                        confirm() {
                            goOTP();
                            $vfm.hide('DialogBase');
                        },
                    });
                }
            }).catch(() => {
                isLoading.value = false;
            });
        };
        const goOTP = () => {
            router.push({ name: routeName.OTP });
        };

        return {
            postApply,
            isScrollToBottom,
            isLoading,
            content
        };
    },
};
</script>

<style scoped>
.terms-resolve-layer::after {
    content: "";
    position: absolute;
    display: block;
    width: 100%;
    height: 50px;
    background: transparent linear-gradient(180deg, #ffffff00 0%, #ffffff 100%)
        0% 0% no-repeat padding-box;
    bottom: -1px;
}
</style>
